/**
 * Централизованный реестр компонентов для взаимодействия с sidecar
 */
class ComponentRegistry {
  constructor() {
    this.components = new Map();
  }

  /**
   * Регистрирует компонент в реестре
   * @param {string} name - имя компонента
   * @param {object} instance - экземпляр компонента
   */
  register(name, instance) {
    this.components.set(name, instance);
  }

  /**
   * Удаляет компонент из реестра
   * @param {string} name - имя компонента
   */
  unregister(name) {
    this.components.delete(name);
  }

  /**
   * Получает экземпляр компонента
   * @param {string} name - имя компонента
   * @returns {object|null} экземпляр компонента или null
   */
  get(name) {
    return this.components.get(name) || null;
  }

  /**
   * Проверяет, зарегистрирован ли компонент
   * @param {string} name - имя компонента
   * @returns {boolean}
   */
  has(name) {
    return this.components.has(name);
  }

  /**
   * Получает список всех зарегистрированных компонентов
   * @returns {string[]}
   */
  getRegistered() {
    return Array.from(this.components.keys());
  }
}

export default new ComponentRegistry();
